import React, { useState, useEffect } from "react";
import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Button from "@components/Button";
import SectionHeader from "../SectionHeader";
import BrandLogo from "../BrandLogo";
import { useNavigate } from "react-router";
import "./style.scss";

export default NiceModal.create(() => {
  const modal = useModal();
  const navigate = useNavigate();

  console.log(modal.args);
  console.log(modal.args?.ident);

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={"fragrance-2025-redeem-award-modal"}
      disableClose={true}
    >
      <>
        {modal.args?.ident === "set_fragrance_2025" ? (
          <>
            <SectionHeader>
              <strong>Glückwunsch – </strong>das Fragrance Kit gehört dir!
            </SectionHeader>
            <div className="desktop-wrapper">
              Danke fürs Einlösen des{" "}
              <strong>Vuse × Julian Daynov: Signs of You</strong> Fragrance Kit.
              <br />
              <br />
              Dein Paket wird vorbereitet und innerhalb von{" "}
              <strong>5 Werktagen per Kurier</strong> versendet.
            </div>
            <div className="buttons-wrapper">
              <Button
                action={() => {
                  navigate(`/coupons/received/${modal.args?.awardUUID}`);
                  modal.hide();
                }}
              >
                Schliessen
              </Button>
            </div>
          </>
        ) : (
          <>
            <SectionHeader>
              <strong>Dein Reward ist bestätigt!</strong>
            </SectionHeader>
            <div className="desktop-wrapper">
              Danke fürs Einlösen der{" "}
              <strong>Vuse Ultra Premium‑Verpackung.</strong>
              <br />
              <br />
              Dein Paket wird vorbereitet und
              <strong> innerhalb von 7 Werktagen versendet.</strong>
            </div>
            <div className="buttons-wrapper">
              <Button
                action={() => {
                  navigate(`/coupons/received/${modal.args?.awardUUID}`);
                  modal.hide();
                }}
              >
                Schliessen
              </Button>
            </div>
          </>
        )}
      </>
    </Modal>
  );
});
